import { AA, AA as AAShieldStarter } from "@utils/adobeAnalyticsSS";
import { CCPAcquisitionDataLayerObject, CCPDataLayer, CCPFormDataLayerObject, CCPUserDataLayerObject } from "../DataLayer/Datalayer.model";
import { dataObjectUpdater } from "@pages/EverGreen/Helpers/analyticsHelper";
declare const window: any;

export const trackOnLoad = (props?:{formUpdated?: Partial<CCPFormDataLayerObject>,acquisitionUpdated?: Partial<CCPAcquisitionDataLayerObject>, userUpdated?: Partial<CCPUserDataLayerObject>, errorPage?:{errorCode?:string, errorMsg?:string}}, nav5Tracking?: string) => {
    const AA = AAShieldStarter.getInstance();
    const { form, acquisition, user, page } = AA.digitalData as CCPDataLayer;

    form.name = "";
    form.error.fieldLabels = [];
    form.error.messages = [];
    form.error.numErrors = "0";

    if(props?.acquisitionUpdated){
      dataObjectUpdater(acquisition, props.acquisitionUpdated)
    }
    if(props?.formUpdated){
      dataObjectUpdater(form, props.formUpdated)
    }
    if(props?.userUpdated){
      dataObjectUpdater(user, props.userUpdated)
    }
      page.errorCode = props?.errorPage?.errorCode || ""
      page.errorMessage = props?.errorPage?.errorMsg || ""
  
    AA.trackPageLoad({ form, acquisition, page, user }, nav5Tracking);
  };

  // props?:{form?:string, error?:{fieldLabels?:[], messages?:[], numErrors?: "0"}

  export const trackOnFormStartOrSuccess= (formName?:string, isSuccess?:boolean)=>{
    const AA = AAShieldStarter.getInstance();
    const { form, page } = AA.digitalData as CCPDataLayer;

    // if(formName === form.name && !isSuccess && formName !== "ccp_contact_us_form"){
    //   return;
    // }
    // if(formName !== form.name && isSuccess  && formName !== "ccp_contact_us_form"){
    //   return;
    // }

    // form.name = props?.form || "";
    // form.error.fieldLabels = props?.error?.fieldLabels ||  [];
    // form.error.messages =  props?.error?.messages || [];
    // form.error.numErrors = props?.error?.numErrors || "0";   
    
    form.name = formName|| "";
    form.error.fieldLabels =   [];
    form.error.messages =  [];
    form.error.numErrors ="0";   
    page.errorCode =  ""
    page.errorMessage =  ""
    
    if(isSuccess){
      console.log(` && formName !== "ccp_contact_us_form"`)
      AA.trackFormCompleted({form}, "");
    }else {
      console.log(` && formName !== "ccp_contact_us_form" start`)

    AA.trackPageStart({form})}

  }

  export const updateMarketing = (isMarketingOptin: "Yes" | "No")=>{
    const AA = AAShieldStarter.getInstance();
    const { acquisition } = AA.digitalData as CCPDataLayer;
    acquisition.customer.marketingOptIn = isMarketingOptin

    if (window._satellite && window.digitalData) {
      Object.assign(window.digitalData, acquisition);
      sessionStorage.setItem(
        "singlife_aa_cached",
        JSON.stringify(window.digitalData)
      );
    }

  }

  export const trackOnFormError = ({name, error}: {name:string, error:{fieldLabels: string[], messages: string[], numErrors:string}})=>{
    const AA = AAShieldStarter.getInstance();
    const { form, page } = AA.digitalData as CCPDataLayer;
    form.name = name|| "";
    form.error.fieldLabels =   [];
    form.error.messages =  [];
    form.error.numErrors ="0";   
    page.errorCode =  ""
    page.errorMessage =  ""
    Object.assign(form.error, error);

    AA.trackFormCompleted({form, page}, 'error')
    
  }


  export const trackOnSuccess = (props?:{formUpdated?: Partial<CCPFormDataLayerObject>,acquisitionUpdated?: Partial<CCPAcquisitionDataLayerObject>, userUpdated?: Partial<CCPUserDataLayerObject>}) => {
    const AA = AAShieldStarter.getInstance();
    let { form, acquisition,user } = AA.digitalData as CCPDataLayer;
    form.name = "";
    form.error.fieldLabels = [];
    form.error.messages = [];
    form.error.numErrors = "0";
    
    if(props?.acquisitionUpdated){
      dataObjectUpdater(acquisition, props.acquisitionUpdated)
    }
    if(props?.formUpdated){
      dataObjectUpdater(form, props.formUpdated)
    }
    if(props?.userUpdated){
      dataObjectUpdater(user, props.userUpdated)
    }
  
    AA.trackPurchasSuccessful({ form, acquisition });
  };

  export const trackOnCTA = (props?:{ctaText: string, ctaType: string, type?: "track_document_download"})=>{
    const AA = AAShieldStarter.getInstance();
    let {cta} = AA.digitalData as CCPDataLayer

    cta.ctaText = props?.ctaText || "";
    cta.ctaType = props?.ctaType || "";

    AA.trackCTAClick({cta},props?.type)

  }